module.exports = __webpack_public_path__ + "static/media/distribution.c015cd27.jpg";